// 더보기 (A4) — 회사/사용자 → 언어 → 차량관리 화면으로 보기 → 앱 안내 → 로그아웃.
// props: { user, screenMode, onLogout }
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { T, R, FONT } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import SimpleCard from '../parts/SimpleCard';
import ConfirmSheet from '../parts/ConfirmSheet';
import Glyph from '../parts/Glyph';
import LangSelect from '../parts/LangSelect';
import LtrText from '../parts/LtrText';
// 상수·동작은 데스크톱 드롭다운(parts/WhoMenu.js)과 공용 — v2/simple/moreActions.js.
import { APP_STORE, PLAY_STORE, goFullMode, logoutSimple } from '../moreActions';

var page = { display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 720, margin: '0 auto' };
var title = { fontSize: 19, fontWeight: 800, letterSpacing: '-.35px', color: T.navy, marginBottom: 4 };
var row = { display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', borderBottom: '1px solid ' + T.bdSoft, minWidth: 0 };
var rowLast = Object.assign({}, row, { borderBottom: 0 });
var tx = { flex: 1, minWidth: 0 };
var t1 = { display: 'block', fontSize: 13, fontWeight: 700, color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var t2 = { display: 'block', fontSize: 11.5, color: T.muted, marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var icon = { width: 32, height: 32, borderRadius: R.md, flex: 'none', display: 'grid', placeItems: 'center', color: T.card, fontSize: FONT.label, fontWeight: 800 };
var actionBtn = { border: 0, background: 'none', padding: 0, margin: 0, font: 'inherit', textAlign: 'start', cursor: 'pointer', width: '100%' };
var linkBtn = { display: 'inline-flex', alignItems: 'center', height: 28, padding: '0 10px', borderRadius: R.md,
  border: '1px solid ' + T.accentBd, background: T.card, color: T.accentPress, fontSize: 11.5, fontWeight: 700,
  cursor: 'pointer', fontFamily: 'inherit', textDecoration: 'none', whiteSpace: 'nowrap' };
var chev = { color: T.faint, flex: 'none', fontSize: 15, lineHeight: 1 };

function Row(props) {
  var inner = (<React.Fragment>
    <span style={Object.assign({}, icon, { background: props.tone || T.muted })}><Glyph id={props.glyph} /></span>
    <span style={tx}>
      <span style={t1}>{props.title}</span>
      {props.sub ? <span style={t2}>{props.sub}</span> : null}
    </span>
    {props.right}
    {props.onClick ? <span style={chev}>›</span> : null}
  </React.Fragment>);
  var style = props.last ? rowLast : row;
  if (!props.onClick) return <div style={style}>{inner}</div>;
  return <button type="button" style={Object.assign({}, actionBtn, style)} onClick={props.onClick}>{inner}</button>;
}

function SimpleMore(props) {
  var t = useT();
  var navigate = useNavigate();
  var user = props.user || {};
  var st = useState('');
  var sheet = st[0], setSheet = st[1];

  var companyName = user.companyNameEn || user.companyName || user.name || '';

  var goFull = function () {
    setSheet('');
    goFullMode(props.screenMode, navigate);
  };
  var doLogout = function () {
    setSheet('');
    logoutSimple(props.onLogout, navigate);
  };

  return (<div style={page}>
    <h2 style={title}>{t('shellTabMore')}</h2>

    <SimpleCard>
      <Row tone={T.navy} glyph="building" title={<LtrText>{companyName}</LtrText>} sub={t('moreCompany')} />
      <Row tone={T.muted} glyph="user" title={<LtrText>{user.name || ''}</LtrText>} sub={t('moreProfile')} last />
    </SimpleCard>

    <SimpleCard>
      <Row tone={T.accent} glyph="translate" title={t('settingsLanguage')} right={<LangSelect variant="row" />} />
      <Row tone={T.ink} glyph="apps" title={t('simpleShowAll')} sub={t('simpleShowAllSub')} last
        onClick={function () { setSheet('full'); }} />
    </SimpleCard>

    <SimpleCard>
      <Row tone={T.muted} glyph="info" title={t('moreAppInfo')} right={(<span style={{ display: 'flex', gap: 6 }}>
        <a style={linkBtn} href={APP_STORE} target="_blank" rel="noreferrer">App Store</a>
        <a style={linkBtn} href={PLAY_STORE} target="_blank" rel="noreferrer">Google Play</a>
      </span>)} />
      <Row tone={T.danger} glyph="power" title={t('settingsProfileLogout')} last
        onClick={function () { setSheet('logout'); }} />
    </SimpleCard>

    <ConfirmSheet open={sheet === 'full'} title={t('simpleB1ShowAllSheetTitle')}
      headline={t('simpleB1SheetFullHeadline')} sub={t('simpleB1SheetFullSub')} hint={t('simpleShowAllHint')}
      confirmLabel={t('simpleShowAll')} onConfirm={goFull} onClose={function () { setSheet(''); }} />
    <ConfirmSheet open={sheet === 'logout'} title={t('settingsProfileLogout')}
      confirmLabel={t('settingsProfileLogout')} onConfirm={doLogout} onClose={function () { setSheet(''); }} />
  </div>);
}

export default SimpleMore;
